import sdl from '@jds/react-generated-sdl/JDSContentCard';
import type { JDSContentCardProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, CardProps } from '../logic';

const Component = (props: CardProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    size = 'xtra-small',
    orientation = 'vertical',
    imageRatio = 'wide',
    shadow = true,
    condensed = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { size, orientation, imageRatio, shadow, condensed, ...rest },
    'JDSContentCard',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Card = withLogic(Component) as React.FC<CardProps> & {
  slotName?: string;
};

Card.displayName = 'Card';
Card.slotName = 'jds_content_card';

export { Card, type JDSContentCardProps };
